export const showLoadingScreen = () => {
  $('body').addClass('loading');
  window.setTimeout(removeLoadingScreen, 5000);
};

export const removeLoadingScreen = () => {
  console.log('click on loading-modal');
  $('body').removeClass('loading');
};

export default () => {
  // Loading animation for view and feel an response of clicking anything
  window.onbeforeunload = () => {
    showLoadingScreen();
  };

  $(document).ready(($) => {
    $('.loading-modal').click(() => {
      window.setTimeout(removeLoadingScreen, 2000);
    });
  });
};
